module.exports = __webpack_public_path__ + "img/1006656112.3cd44b8c.png";